import _ from 'lodash';
import { AnyAction } from 'redux';
import ILoanEmail from '~Api/LoanEmail/ILoanEmail';
import { IDictionary } from '~utilities/IDictionary';
import {
    ILoanEmailTextSetAction,
    ILoanEmailsListAction,
    ILoanEmailsSetAction,
} from './actions';
import LoanEmailsActionsEnum from './ActionsEnum';

export interface ILoanEmailsState {
    emails: IDictionary<ILoanEmail>;
    pageCounts: IDictionary<number>;
    pageEmailUuids: IDictionary<string[]>;
    pageNumbers: IDictionary<number>;
    texts: IDictionary<string>;
}

const initialData: ILoanEmailsState = {
    emails: {},
    pageCounts: {},
    pageEmailUuids: {},
    pageNumbers: {},
    texts: {},
};

export function loanEmailsReducer(state: ILoanEmailsState = initialData, action: AnyAction): ILoanEmailsState {
    switch (action.type) {
        case LoanEmailsActionsEnum.LoanEmailsList: {
            const typedAction: ILoanEmailsListAction = action as ILoanEmailsListAction;

            return {
                ...state,
                pageEmailUuids: {
                    ...state.pageEmailUuids,
                    [typedAction.loanUuid]: null,
                },
                pageNumbers: {
                    ...state.pageNumbers,
                    [typedAction.loanUuid]: typedAction.pageNumber,
                },
            };
        }

        case LoanEmailsActionsEnum.LoanEmailsSet: {
            const typedAction: ILoanEmailsSetAction = action as ILoanEmailsSetAction;

            return {
                ...state,
                emails: {
                    ...state.emails,
                    ..._.keyBy(typedAction.emails, 'uuid'),
                },
                pageCounts: {
                    ...state.pageCounts,
                    [typedAction.loanUuid]: typedAction.count,
                },
                pageEmailUuids: {
                    ...state.pageEmailUuids,
                    [typedAction.loanUuid]: _.map(typedAction.emails, (email: ILoanEmail): string => email.uuid),
                },
            };
        }

        case LoanEmailsActionsEnum.LoanEmailTextSet: {
            const typedAction: ILoanEmailTextSetAction = action as ILoanEmailTextSetAction;

            return {
                ...state,
                texts: {
                    ...state.texts,
                    [typedAction.loanEmailUuid]: typedAction.text,
                },
            };
        }

        default:
            return state;
    }
}
